module.exports = __webpack_public_path__ + "static/media/10.77ca2e1e.jpeg";